'use es6';

const makeDecoratorDisplayName = (decoratorName, DecoratingComponent) => {
  const decoratingName = DecoratingComponent.displayName || DecoratingComponent.name || 'Component';
  return `${decoratorName}(${decoratingName})`;
};

export default makeDecoratorDisplayName;